import React from 'react';
import HomePage from '.';

export const HomeRoutes = {
  path: '',
  element: <HomePage />,
};

export default HomeRoutes;
